<template>
	<div v-if="inline">
		<div class="bg-white flex pb-20">
			<div class="flex-1 flex md:ml-5">
				<div class="w-full md:max-w-xl mx-auto">

					<div class="overflow-auto">
						<div>
							<div v-if="inlineShow == 'resetPassword'">
								<div class="block">
									<tw-button align='none' variant="secondary" :full-width="false"  @clicked="inlineShow='signIn'">
										<div class="flex gap-2">
											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
												<path d="M10 13h8V7h-8V2l-8 8 8 8v-5z"/>
											</svg>
											<span>Back</span>
										</div>
									</tw-button>
								</div>
								<div class="text-gray-700 font-bold text-2xl flex-1 mt-2">
									<h3>Reset your password</h3>
								</div>
						<div class="mt-6">
							<tw-alert :show="errors.reset !== false" type="error" class="mb-3">
								<span v-for="inputError in errors.reset">
									<span class="block" v-for="error in inputError">
										{{ error }}
									</span>
								</span>
							</tw-alert>
							<tw-alert :show="success.reset !== false" type="success" class="mb-3">
								<span v-for="inputFeedback in success.reset">
									<span class="block" v-for="feedback in inputFeedback">
										{{ feedback }}
									</span>
								</span>
							</tw-alert>

					        <div class="input-container">
					      		<tw-input name="Email" icon="mail" placeholder="Email address" @updated="updateResetInputs"></tw-input>
					      	</div>

					        <div class="mt-8">
					        	<tw-button size="lg" @clicked="forgotPassword" :disabled="disabledLoading">{{ (disabledLoading) ? 'Loading...' : 'Send Email' }}</tw-button>
					        </div>
					    </div>
					</div>

					<div v-else>

						<div class="flex gap-2 items-center mt-4">

							<div class="text-gray-700 font-bold text-2xl flex-1">
								<h3 v-if="inlineShow == 'signIn'">Sign in</h3>
								<h3 v-else-if="inlineShow == 'register'">Register</h3>
							</div>
							<a href='#' @click="toggleInlineShow">
								<tw-button variant="secondary" v-if="inlineShow == 'signIn'">Need an account?</tw-button>
								<tw-button variant="secondary" v-else-if="inlineShow == 'register'">Already have an account?</tw-button>
							</a>

						</div>


						<div class="mt-6" v-if="inlineShow == 'register'">
							<tw-alert :show="errors.register !== false" type="error" class="mb-3">
								<span v-for="inputError in errors.register">
									<span class="block" v-for="error in inputError">
										{{ error }}
									</span>
								</span>
							</tw-alert>

				          <div class="space-y-2">

				          	<div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
					          	<div>
						      		<tw-input name="First Name" icon="person" placeholder="First Name" @updated="updateRegisterInputs" :val="form.register.first_name"></tw-input>
						      	</div>

						      	<div>
						      		<tw-input name="Last Name" icon="person" placeholder="Last Name" @updated="updateRegisterInputs" :val="form.register.last_name"></tw-input>
						      	</div>
					      	</div>

                           <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                <div>
                                    <tw-input name="Phone" icon="phone" placeholder="Phone Number" @updated="updateRegisterInputs" :val="form.register.phone"></tw-input>
                                </div>
                                <div>
                                    <tw-input name="Date of Birth" icon="dob" placeholder="Date of Birth" @updated="updateRegisterInputs" :val="form.register.date_of_birth" type="datepicker" :datepicker_state="datepicker_state"></tw-input>
                                </div>
                            </div>

				          	<div>
					      		<tw-input name="Email address" icon="mail" placeholder="Email address" @updated="updateRegisterInputs" :val="form.register.email_address"></tw-input>
					      	</div>

					        <div>
					        	<tw-input name="Password" input-type="password" icon="password" placeholder="Password" tooltip="Password must be at least 6 characters and contain at least one lowercase/uppercase letter & digit" @updated="updateRegisterInputs" :val="form.register.password"></tw-input>
					        </div>

							<div>
					        	<tw-input name="Retype password" input-type="password" icon="password" placeholder="Retype Password" @updated="updateRegisterInputs" @event:enter='registerClient'></tw-input>
					    	</div>

					        <div class="mt-8">
					        	<tw-button size="lg" :disabled="registerDisabled" @clicked="registerClient">Register</tw-button>
					        </div>
				          </div>
				        </div>

				        <div class="mt-6" v-if="inlineShow == 'signIn'">
							<tw-alert :show="errors.login !== false" type="error" class="mb-3">
								<span v-for="inputError in errors.login">
									<span class="block" v-for="error in inputError">
										{{ error }}
									</span>
								</span>
							</tw-alert>

							<div class="space-y-2">
						        <div>
						      		<tw-input name="Email address" icon="mail" placeholder="Email address" @updated="updateLoginInputs" :val="form.login.email_address"></tw-input>
						      	</div>

						        <div>
						        	<tw-input name="Password" input-type="password" icon="password" placeholder="Password" @updated="updateLoginInputs" :val="form.login.password" @event:enter='signInClient'></tw-input>
						        </div>

						        <div class="mt-6 flex items-center justify-between">
						          <div class="text-sm leading-5">
						            <a href="#" class="font-medium text-teal-600 no-underline hover:text-teal-500 focus:outline-none focus:underline transition ease-in-out duration-150" @click="inlineShow = 'resetPassword'">
						              Forgot your password?
						            </a>
						          </div>
						        </div>
					        </div>

					        <div class="mt-8">
					        	<tw-button size="lg" @clicked="signInClient">Sign in</tw-button>
					        </div>
					    </div>
				    </div>
		        </div>
			  </div>
			    <div class="mt-6">
			        <div class="relative">
			          <div class="absolute inset-0 flex items-center">
			            <div class="w-full border-t border-gray-300"></div>
			          </div>
			          <div class="relative flex justify-center text-sm">
			            <span class="px-2 bg-white text-gray-500">
			              Or continue with
			            </span>
			          </div>
			        </div>

			        <div class="mt-6 grid grid-cols-3 gap-3">
			          <div>
			            <a href="#" class="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" @click="loginWithSocial('facebook')">
			              <span class="sr-only">Sign in with Facebook</span>
			              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
			                <path fill-rule="evenodd" d="M20 10c0-5.523-4.477-10-10-10S0 4.477 0 10c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V10h2.54V7.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V10h2.773l-.443 2.89h-2.33v6.988C16.343 19.128 20 14.991 20 10z" clip-rule="evenodd" />
			              </svg>
			            </a>
			          </div>

			          <div>
			            <a href="#" class="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" @click="loginWithSocial('twitter')">
			              <span class="sr-only">Sign in with Twitter</span>
			              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
			                <path d="M6.29 18.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0020 3.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.073 4.073 0 01.8 7.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 010 16.407a11.616 11.616 0 006.29 1.84" />
			              </svg>
			            </a>
			          </div>
			        </div>
			    </div>

		    </div>
		  </div>
		</div>

	</div>
	<div v-else>
		<div class="flex-1 flex flex-col justify-center pb-12 lg:flex-none w-full">
			<div id="social-container" v-if="show == 'options'">
				<div class="mx-auto w-full">
				  <div class="modal-title">
				    <h3>
				      Sign in <span class="hidden sm:inline-block">to your account</span>
				    </h3>
				  </div>

				  <div class="sign_in_container">
				    <div>
				      <div>
				        <div class="sign_in_grid">
				          <div>
				            <span class="sign_in_element">
				              <a class="no-underline" aria-label="Sign in with Facebook" @click="loginWithSocial('facebook')">
				              	<span class="icon-container">
					                <svg fill="currentColor" viewBox="0 0 20 20">
					                  <path fill-rule="evenodd" d="M20 10c0-5.523-4.477-10-10-10S0 4.477 0 10c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V10h2.54V7.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V10h2.773l-.443 2.89h-2.33v6.988C16.343 19.128 20 14.991 20 10z" clip-rule="evenodd"/>
					                </svg>
				                </span>
				                <span class="text-container">Facebook</span>
				              </a>
				            </span>
				          </div>

				          <div>
				            <span class="sign_in_element">
				              <a class="no-underline" aria-label="Sign in with Twitter" @click="loginWithSocial('twitter')">
				              	<span class="icon-container">
					                <svg fill="currentColor" viewBox="0 0 20 20">
					                  <path d="M6.29 18.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0020 3.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.073 4.073 0 01.8 7.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 010 16.407a11.616 11.616 0 006.29 1.84"/>
					                </svg>
					            </span>
				                <span class="text-container">Twitter</span>
				              </a>
				            </span>
				          </div>

				          <div>
				            <!-- <span class="sign_in_element">
				              <a class="no-underline" aria-label="Sign in with Strava" @click="loginWithSocial('strava')">
				              	<span class="icon-container">
					                <svg role="img" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
					                	<title/>
					                	<path d="M15.387 17.944l-2.089-4.116h-3.065L15.387 24l5.15-10.172h-3.066m-7.008-5.599l2.836 5.598h4.172L10.463 0l-7 13.828h4.169"/>
					                </svg>
				            	</span>
				                <span class="text-container">Strava</span>
				              </a>
				            </span> -->
				          </div>

				          <div>
				            <span class="sign_in_element">
				              <a class="no-underline" aria-label="Sign in with Email" @click="show = 'signIn'">
				              	<span class="icon-container">
					                <svg role="img" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
					                	<path d="M13.6 13.47A4.99 4.99 0 0 1 5 10a5 5 0 0 1 8-4V5h2v6.5a1.5 1.5 0 0 0 3 0V10a8 8 0 1 0-4.42 7.16l.9 1.79A10 10 0 1 1 20 10h-.18.17v1.5a3.5 3.5 0 0 1-6.4 1.97zM10 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
					                </svg>
					            </span>
				                <span class="text-container">Email</span>
				              </a>
				            </span>
				          </div>
				        </div>

				        <div v-if="register">
							<div class="my-4 sm:my-8 relative">
								<div class="absolute inset-0 flex items-center">
								  <div class="w-full border-t border-gray-300"></div>
								</div>
								<div class="relative flex justify-center text-sm leading-5">
								  <span class="px-2 bg-white text-gray-500">
								    Need an account?
								  </span>
								</div>
							</div>

							<div>
								<span class="sign_in_element secondary">
								  <a class="no-underline" aria-label="Register" @click="show = 'register'">
								    <span class="text-container">Register</span>
								  </a>
								</span>
							</div>
				        </div>
				      </div>
				    </div>
				  </div>
				</div>
			</div>

			<div id="sign-container" v-else-if="show == 'signIn'">
				<div class="back-btn-container">
					<a class="back-btn" @click="show='options'">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
							<path d="M10 13h8V7h-8V2l-8 8 8 8v-5z"/>
						</svg>
						<span>Back</span>
					</a>
				</div>
				<div class="modal-title">
					<h3>
						Sign into your account
					</h3>
				</div>
				<div class="mt-6">
					<tw-alert :show="errors.login !== false" type="error" class="mb-3">
						<span v-for="inputError in errors.login">
							<span class="block" v-for="error in inputError">
								{{ error }}
							</span>
						</span>
					</tw-alert>

			        <div class="input-container">
			      		<tw-input :val="form.login.email" name="Email address" icon="mail" placeholder="Email address" @updated="updateLoginInputs"></tw-input>
			      	</div>

			        <div class="input-container">
			        	<tw-input :val="form.login.password" name="Password" input-type="password" icon="password" placeholder="Password" @updated="updateLoginInputs"></tw-input>
			        </div>

			        <div class="mt-6 flex items-center justify-between">
			          <div class="text-sm leading-5">
			            <a href="#" class="font-medium text-teal-600 no-underline hover:text-teal-500 focus:outline-none focus:underline transition ease-in-out duration-150" @click="show = 'resetPassword'">
			              Forgot your password?
			            </a>
			          </div>
			        </div>

			        <div class="mt-8">
			        	<tw-button size="lg" @clicked="signInClient">Sign in</tw-button>
			        </div>
			    </div>
			</div>

			<div id="forgot-container" v-else-if="show == 'resetPassword'">
				<div class="back-btn-container">
					<a class="back-btn" @click="show='signIn'">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
							<path d="M10 13h8V7h-8V2l-8 8 8 8v-5z"/>
						</svg>
						<span>Back</span>
					</a>
				</div>
				<div class="modal-title">
					<h3>
						Reset your password
					</h3>
				</div>
				<div class="mt-6">
					<tw-alert :show="errors.reset !== false" type="error" class="mb-3">
						<span v-for="inputError in errors.reset">
							<span class="block" v-for="error in inputError">
								{{ error }}
							</span>
						</span>
					</tw-alert>
					<tw-alert :show="success.reset !== false" type="success" class="mb-3">
						<span v-for="inputFeedback in success.reset">
							<span class="block" v-for="feedback in inputFeedback">
								{{ feedback }}
							</span>
						</span>
					</tw-alert>

			        <div class="input-container">
			      		<tw-input name="Email" icon="mail" placeholder="Email address" @updated="updateResetInputs"></tw-input>
			      	</div>

			        <div class="mt-8">
			        	<tw-button size="lg" @clicked="forgotPassword" :disabled="disabledLoading">{{ (disabledLoading) ? 'Loading...' : 'Send Email' }}</tw-button>
			        </div>
			    </div>
			</div>

			<div id="register-container" class="register-form" v-else-if="show == 'register'">
				<div class="back-btn-container">
					<a class="back-btn" @click="show='options'">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
							<path d="M10 13h8V7h-8V2l-8 8 8 8v-5z"/>
						</svg>
						<span>Back</span>
					</a>
				</div>
				<div class="modal-title">
					<h3>
						Create an account
					</h3>
				</div>
				<div class="mt-6">

					<tw-alert :show="errors.register !== false" type="error" class="mb-3">
						<span v-for="inputError in errors.register">
							<span class="block" v-for="error in inputError">
								{{ error }}
							</span>
						</span>
					</tw-alert>

					<div class="input-container">
			      		<tw-input name="Email address" icon="mail" placeholder="Email address" @updated="updateRegisterInputs"></tw-input>
			      	</div>

			        <div class="input-container">
			        	<tw-input name="Password" input-type="password" icon="password" placeholder="Password" @updated="updateRegisterInputs"></tw-input>
			        </div>

					<div class="input-container">
			        	<tw-input name="Retype password" input-type="password" icon="password" placeholder="Retype Password" @updated="updateRegisterInputs"></tw-input>
			    	</div>

			        <div class="mt-8">
			        	<tw-button size="lg" :disabled="registerDisabled" @clicked="registerClient">Register</tw-button>
			        </div>

			    </div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'quote.initial.account',
		props: {
			register: {
				default: true
			},
			inline: {
				default: false,
			},
			email: {
				default: '',
			},
			first_name: {
				default: '',
			},
			last_name: {
				default: '',
			},
			phone: {
				default: '',
			},
            dob: {
                default: '',
            },

		},
		data() {
			return {
				show: 'options',
				inlineShow: 'register',
				disabledLoading:false,
				errors: {
					login: false,
					register: false,
					reset: false,
				},
				success: {
					reset: false,
				},
				form: {
					login: {
						email_address:null,
						password:null
					},
					register: {},
					reset: {},
				},
                datepicker_state: {
                    date: new Date(new Date().setFullYear(new Date().getFullYear() - 18)),
                    disabledDates: {
                        from: new Date(new Date().setFullYear(new Date().getFullYear() - 18)),
                    }
			    },
			}
		},
		watch: {
			show() {
				this.$emit('changed', true);
			},
			email() {
				this.form.register.email_address = this.email;
			},
			first_name() {
				this.form.register.first_name = this.first_name;
			},
			last_name() {
				this.form.register.last_name = this.last_name;
			},
			phone() {
				this.form.register.phone = this.phone;
			},
            dob() {
				this.form.register.date_of_birth = this.date_of_birth;
			}
		},
		mounted() {
			this.form.register.email_address 	= this.email;
			this.form.register.first_name 		= this.first_name;
			this.form.register.last_name 		= this.last_name;
			this.form.register.phone 			= this.phone;
            this.form.register.date_of_birth 	= this.date_of_birth;
		},
		computed: {
			registerDisabled() {
				let d = false;

				if(!this.form.register.email_address || this.form.register.email_address == '') {
					d = true;
				}

				if(!this.form.register.password || this.form.register.password == '') {
					d = true;
				}

				if(!this.form.register.retype_password || this.form.register.retype_password == '') {
					d = true;
				}

                if(!this.form.register.date_of_birth || this.form.register.date_of_birth == '') {
					d = true;
				}

				return d;
			}
		},
		methods: {
			toggleInlineShow() {
				if(this.inlineShow == 'register') {
					this.inlineShow = 'signIn';
				} else {
					this.inlineShow = 'register';
				}
			},
			updateLoginInputs(e) {
				const self = this;

				// store form data/errors for each login input
				Object.keys(e).forEach(function(key) {
					Vue.set(self.form.login, key, e[key]['value']);
				});
			},
			updateRegisterInputs(e) {
				const self = this;

				// store form data/errors for each register input
				Object.keys(e).forEach(function(key) {
					Vue.set(self.form.register, key, e[key]['value']);
				});
			},
			updateResetInputs(e) {
				const self = this;

				// store form data/errors for each password reset input
				Object.keys(e).forEach(function(key) {
					Vue.set(self.form.reset, key, e[key]['value']);
				});
			},
			signInClient(e) {
				const self = this;

				// start loading gif
				self.isLoading = true;

				// register client
				axios.post('quote/login', this.form.login)
					 .then((resp) => {
			 			// stop loading gif
			 			self.isLoading = false;

					 	if(resp.data) {
					 		if(resp.data.success) {
					 			self.$emit('loggedIn', true);
					 		} else {
					 			self.errors.login = [{'error': resp.data.feedback}];
					 		}
					 	}
					 })
					 .catch((error) => {
					 	// stop loading
					 	self.isLoading = false;

					 	self.errors.login = [{'error': 'Error - ' + error}];
					 })
			},
			registerClient(e) {
				const self = this;

				// start loading gif
				self.isLoading = true;

				// register client
				axios.post('quote/client', this.form.register)
					 .then((resp) => {
			 			// stop loading gif
			 			self.isLoading = false;

					 	if(resp.data) {
					 		if(resp.data.success) {
					 			self.$emit('loggedIn', true);
					 		} else {
					 			self.errors.register = resp.data.feedback.errors;
					 		}
					 	}
					 })
					 .catch((error) => {
					 	// stop loading
					 	self.isLoading = false;

					 	self.errors.register = [{'error': 'Error - ' + error}];
					 })
			},
			loginWithSocial(type) {
				const self = this;

				let loginPopup = window.open(this.baseUrl + '/social_login/'+type, '_blank', 'width=900,height=600');

				let loginCheck = setInterval(function() {
					self.$emit('social', {
						check: loginCheck,
						popup: loginPopup
					});
				}, 2000);
			},
			forgotPassword() {
				const self = this;

				self.disabledLoading = true;

				// register client
				axios.post('password/email', this.form.reset)
					 .then((resp) => {
			 			// stop loading gif
			 			self.disabledLoading = false;

					 	self.success.reset = [{'success': 'A reset link has been sent to your email'}];
					 })
					 .catch((error) => {
					 	// stop loading
					 	self.disabledLoading = false;

					 	self.errors.reset = [{'error': 'Error - ' + error}];
					 })
			},
		}
	}
</script>
